import React, { Component } from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import NativeSelect from "@material-ui/core/NativeSelect";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import InputBase from "@material-ui/core/InputBase";
import { authHeader, history } from "../../helpers";
import api from "../../constants/api";
import { getAccountsService } from "../../actions/account";
import BreadCrumbNav from "../BreadCrumbNav";
import { setCookie, getUser, checkError,validatePassword } from "../../helpers";
import Autocomplete from '@material-ui/lab/Autocomplete';
import swal from 'sweetalert';
import { postApi } from '../../helpers/http';
import "./AccountEdit.css";
import { Block } from "@material-ui/icons";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

const kRole = ["一般", "一般管理者", "管理者"];
const kCanEditRole = [false, false, true, true];
const kCanResetPW = [false, false, true, true];
function Alert(props) {
   return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const BootstrapInput = withStyles((theme) => ({
   root: {
      "label + &": {
         marginTop: theme.spacing(3),
      },
   },
   input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid rgb(118, 118, 118)",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
         "-apple-system",
         "BlinkMacSystemFont",
         '"Segoe UI"',
         "Roboto",
         '"Helvetica Neue"',
         "Arial",
         "sans-serif",
         '"Apple Color Emoji"',
         '"Segoe UI Emoji"',
         '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
         borderRadius: 4,
         borderColor: "#80bdff",
         boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
   },
}))(InputBase);

class AccountEdit extends Component {
   constructor(props) {
      super(props);
      this.state = {
         offset: 0,
         limit: 1000,
         password_now: "",
         password_new: "",
         passwordConfirm: "",
         password_reset: "",
         enable2fa: "0",
         active_flag: "0",
         department_id: "",
         department_name: "",
         i_num: "",
         login_email: "",
         pc_name: "",
         time_zone: "",
         role: "",
         user_id: "",
         user_name: "",
         tmp_user_id: "",
         openAlert: false,
         editSuccess: false,
         showPasswordNow: false,
         showPasswordNew: false,
         showPasswordConfirm: false,
         showPasswordReset: false,
         showPopup: false,
         isRoleChange: false,
      };
   }

   componentDidMount() {
      const { getSettings } = this.props;
      const query = new URLSearchParams(this.props.location.search);
      const accountId = query.get('id');
      const paramsUserMaster = {
         offset: 0,
         limit: this.state.limit,
         table_name: "user_master",
         process_type: "getMasterList",
      };
      getSettings(paramsUserMaster);

      const loginEmail = localStorage.getItem("email");

      const paramsAccount = {
         offset: 0,
         limit: this.state.limit,
         user_id: Number(accountId)
      };

      getAccountsService(paramsAccount).then((userAccounts) => {
         if ( userAccounts && userAccounts.data && userAccounts.data.detailData.length > 0 ) {
            const userAccount = userAccounts.data.detailData.find(
               x => x.login_email === loginEmail
            );

            if (userAccount) {
               this.setState({
                  enable2fa: Number(userAccount.enable2fa),
                  active_flag: Number(userAccount.active_flag),
                  department_id: Number(userAccount.department_id),
                  department_name: userAccount.department_name,
                  i_num: Number(userAccount.i_num),
                  login_email: userAccount.login_email,
                  pc_name: userAccount.pc_name,
                  role: Number(userAccount.role),
                  user_id: Number(userAccount.user_id),
                  user_name: userAccount.user_name,
                  time_zone: userAccount.time_zone,
               });

               // localStorage.removeItem("email");
            } 
         } 
      });

   }

   changeLocation = (event) => {
      this.setState({ time_zone: event.target.value });
    };
   render() {
      const user = getUser();
      const { usersMaster } = this.props;
      // console.log(usersMaster);

      const sortedUsers = [...(usersMaster.detailData || [])].sort((a, b) =>
         (a.name || "").localeCompare(b.name || "", undefined, {
                               sensitivity: "base",
                               numeric: true
                              })
                           );

      const changeUserMaster = (event) => {
         // const { value } = event.target;
         const {id, name} = event.target;
         const selectedUser = usersMaster.detailData.find(user => user.i_num === Number(id));

         console.log("selectedUser:", selectedUser);
         this.setState({
         user_id: selectedUser?.i_num || "",
         user_name: selectedUser?.name || "",
         tmp_user_id: selectedUser?.i_num || "",
         department_name: selectedUser?.department_name || "",
         section_name: selectedUser?.section_name || "",
         });
      };

      const changeEmail = (event) => {
         const { value } = event.target;
         this.setState({ email: value });
      };

      const changeRole = (event) => {
         const { value } = event.target;
         this.setState({ role: Number(value) });
      };

      const changeEnable2FA = (event) => {
         const { value } = event.target;
         this.setState({
            enable2fa: value,
         });
      };

      const changeActiveFlag = (event) => {
         const { value } = event.target;
         this.setState({
            active_flag: value,
         });
      };

      const handleOnBlur = (event) => {
         if (this.state.tmp_user_id == "") {
            this.setState({
              user_id: "",
              user_name: ""
            });
         };
      };
   
      const handleEdit = async (event) => {
         if (this.state.user_id === -1 || this.state.user_id === "") {
           swal({
              title: "設定エラー！",
              text: "名前入力をしてください。",
              icon: "warning",
              buttons: "はい",
              dangerMode: true,
           })
           return;
         }
         // "password": this.state.password,
         swal({
            title: "変更を保存しますか？",  
            icon: "warning",
            buttons: ["いいえ", "はい"],
            dangerMode: true,
         })

         .then(async (confirm) => {
            if (confirm) {
               const data = {
                  process_type: "insertUserAccount",
                  table_name: "user_tb",
                  user_id: Number(this.state.user_id),
                  role: Number(this.state.role),
                  login_email: this.state.login_email,
                  user_name: this.state.user_name,
                  department_id: this.state.department_id,
                  enable2fa: Number(this.state.enable2fa),
                  active_flag: Number(this.state.active_flag),
                  time_zone: this.state.time_zone,
               };
               console.log("登録押下", data);

               try {
                  const json = await postApi(data);
                  if (json.statusCode == 200) {
                     swal({
                           title: "変更しました。",
                           icon: "success",
                           buttons: "はい"
                     }).then(async() => {
                        let user = {};
                        if (localStorage.getItem('user')) {
                          user = JSON.parse(localStorage.getItem('user') || '{}');
                        } else if (sessionStorage.getItem('user')) {
                          user = JSON.parse(sessionStorage.getItem('user') || '{}');
                        };
                        if (this.state.login_email && user && this.state.login_email == user.login_email && this.state.role != user.role) {
                           user.role = this.state.role;
                           if (localStorage.getItem('user')) {
                             localStorage.setItem('user', JSON.stringify(user));
                           } else if (sessionStorage.getItem('user')) {
                             sessionStorage.setItem('user', JSON.stringify(user));
                           };

                           const newdata = {
                              process_type: "reCreateToken",
                              login_email: this.state.login_email,
                              user_name: this.state.user_name,
                              role: Number(this.state.role),
                              user_id: Number(this.state.user_id),
                              department_id: this.state.department_id
                           };

                           const json_result = await postApi(newdata);
                           if(json_result.statusCode == 200) {
                              setCookie('refresh_token', json_result.data.user.refresh_token);
                              user.token = json_result.data.user.token;
                              localStorage.setItem("user", JSON.stringify(user));
                              sessionStorage.setItem("user", JSON.stringify(user));

                           };
                        };
                        history.push("/index.html?p=accounts");
                     });
                  } else {
                     swal({
                     title: "設定エラー！",
                     text:  json.data || "変更に失敗しました。",
                     icon: "warning",
                     button: "はい",
                     });
                  }
               } catch (error) {
                  swal({
                     title: "設定エラー！",
                     text:  "変更に失敗しました。",
                     icon: "warning",
                     button: "はい",
                  });
               };
               
            } else {
               swal.stopLoading();
               swal.close();
            }
            })
         .catch((err) => {
            if (err) {
               swal({
                  title: "エラー！",
                  text:  "予期しないエラーが発生しました。",
                  icon: "error",
                  buttons: "はい"
               });
            }
         });
      };

      const handleExit = (event) => {
         history.push("/index.html?p=accounts");
      };

      const isValidationInput = (password_now, password_new, passwordConfirm) => {
         if (!password_now) {
            swal({
               title: "設定エラー！",
               text: "元のパスワードを入力してください。",
               icon: "warning",
               button: "はい",
            });
            return false;
         }

         if (!password_new) {
            swal({
               title: "設定エラー！",
               text: "新しいパスワードを入力してください。",
               icon: "warning",
               button: "はい",
            });
            return false;
         }

         if (!passwordConfirm) {
            swal({
               title: "設定エラー！",
               text: "新しいパスワード(確認用)を入力してください。",
               icon: "warning",
               button: "はい",
            });
            return false;
         }

         if (password_new !== passwordConfirm) {
            swal({
               title: "設定エラー！",
               text: "「新しいパスワード」に入力した値が「新しいパスワード（確認用）」に入力した値と一致しません。",
               icon: "warning",
               button: "はい",
            });            
            return false;
         }

         if (!validatePassword(password_new)) {
            return false;
         }

         return true;
      };

      const isValidationPWReset = (newpwreset) => {
    
         if (newpwreset === "") {
            swal({
                title: "設定エラー！",
                text: "新しいパスワードを入力してください。",
                icon: "warning",
                button: "はい",
            });
            return false;
         }
      
         if (!validatePassword(newpwreset)) {
            return false;
         }
      
         return true;
      };

      const handleEditPassword = async () => {
         const { password_now , password_new , passwordConfirm } = this.state;
         if (!isValidationInput(password_now, password_new, passwordConfirm)) {
            return;
         }
         swal({
            title: "変更を保存しますか？",  
            icon: "warning",
            buttons: ["いいえ", "はい"],
            dangerMode: true,
         })
         .then(async (confirm) => {
            if (confirm) {
               const data = {
                  process_type: "updateUserPassword",
                  login_email: this.state.login_email,
                  password_now: this.state.password_now,
                  password_new: this.state.password_new,
               };

               try {
                  const json = await postApi(data);
                  if (json.statusCode == 200) {
                     swal({
                           title: "変更しました。",
                           icon: "success",
                           buttons: "はい"
                     }).then(() => {
                        this.props.login(
                           this.state.login_email, 
                           this.state.password_new, 
                           this.props.autologin, 
                           true
                        ).then(() => {
                           history.push("/index.html?p=accounts");
                        });
                     });
                     } else {
                     swal({
                        title: "設定エラー！",
                        text:  json.data || "変更に失敗しました。",
                        icon: "warning",
                        button: "はい",
                     });
                  };
               } catch (error) {
                  swal({
                     title: "設定エラー！",
                     text:  "変更に失敗しました。",
                     icon: "warning",
                     button: "はい",
                  });
               };
            } else {
               swal.stopLoading();
               swal.close();
            }
         })
         .catch((err) => {
            if (err) {
               swal({
                  title: "エラー！",
                  text:  "予期しないエラーが発生しました。",
                  icon: "error",
                  buttons: "はい"
               });
            }
         });
      };

      const handleResetPassword = async () => {
         const { password_reset } = this.state;
         if (!isValidationPWReset(password_reset)) {
            return;
         }
         swal({
            title: "パスワードをリセットしますか？",  
            icon: "warning",
            buttons: ["いいえ", "はい"],
            dangerMode: true,
         })
         .then(async(confirm) => {
            if (confirm) {
               const data = {
                  process_type: "updateUserPassword",
                  login_email: this.state.login_email,
                  password_reset: this.state.password_reset,
               };

               try {
                  const json = await postApi(data);
                  if (json.statusCode == 200) {
                     swal({
                           title: "リセットしました。",
                           icon: "success",
                           buttons: "はい"
                     }).then(() => {
                        handleClosePopup();
                        this.props.login(
                           this.state.login_email, 
                           this.state.password_reset, 
                           this.props.autologin, 
                           true
                        ).then(() => {
                           history.push("/index.html?p=accounts");
                        });
                     });
                     } else {
                     swal({
                        title: "設定エラー！",
                        text:  json.data || "リセットに失敗しました。",
                        icon: "warning",
                        button: "はい",
                     });
                  };
               } catch (error) {
                  swal({
                     title: "設定エラー！",
                     text:  "リセットに失敗しました。",
                     icon: "warning",
                     button: "はい",
                  });
               };

            } else {
               swal.stopLoading();
               swal.close();
            }
         })
         .catch((err) => {
            if (err) {
               swal({
                  title: "エラー！",
                  text:  "予期しないエラーが発生しました。",
                  icon: "error",
                  buttons: "はい"
               });
            }
         });
      };

      const handleShowResetPassword = () => {
         this.setState({
            showPopup: true,
         });
      };

      const handleClosePopup = () => {
         this.setState({
            showPopup: false,
            password_reset: ""
         });
      };

      const changePasswordNow = (event) => {
         const { value } = event.target;
         this.setState({
            password_now: value,
         });
      };

      const changePasswordNew = (event) => {
         const { value } = event.target;
         this.setState({
            password_new: value,
         });
      };

      const changePasswordConfirm = (event) => {
         const { value } = event.target;
         this.setState({
            passwordConfirm: value,
         });
      };

      const changePasswordReset = (event) => {
         const { value } = event.target;
         this.setState({
            password_reset: value,
         });
      };

      const handleCloseSuccess = () => {
         this.setState({ openAlert: false });
      };

      const toggleShowPasswordNow = () => {
        this.setState({
          showPasswordNow: !this.state.showPasswordNow
        });
      };

      const toggleShowPasswordNew = () => {
        this.setState({
          showPasswordNew: !this.state.showPasswordNew
        });
      };
  
      const toggleShowPasswordConfirm = () => {
        this.setState({
          showPasswordConfirm: !this.state.showPasswordConfirm
        });
      };

      const toggleShowPasswordReset = () => {
        this.setState({
          showPasswordReset: !this.state.showPasswordReset
        });
      };
  
      return (
         <div className="content-container">
            <BreadCrumbNav
               screenName="アカウント編集"
               prevLinks={[
                  { url: "/index.html?p=accounts", text: "アカウント情報編集" },
               ]}
            ></BreadCrumbNav>
            <div className="loginname">ログイン名：{user.username}</div>
            <h1 className="accountedit__heading">アカウント編集</h1>

            <div className="accountedit-form">
               <div className="accountedit-form__group-item">
                 <div className="accountedit-form__item-title">
                     <span>名前</span>
                  </div>
                  <Autocomplete
                    freeSolo
                    className="accountedit-form__item-value"
                    options={sortedUsers || []}
                    getOptionLabel={(option) => option?.name || ""}
                    value={
                      usersMaster.detailData?.find(
                        u => u.i_num === this.state.user_id
                      ) || null
                    }
                    inputValue={this.state.user_name}
                    onChange={(event, newValue) => {
                      changeUserMaster({
                        target: {
                        //   value: newValue ? newValue.i_num : ""
                           id: newValue ? newValue.i_num : -1,
                           name: newValue ? newValue.name : ""
                        }
                      });
                    }}
                    onInputChange={(event, newInputValue) => {
                        this.setState({
                            user_name: newInputValue,
                            tmp_user_id: ""
                        });
                    }}
                    isOptionEqualToValue={(option, value) => option.i_num === value.i_num}
                    clearOnEscape
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className="autocomplete-filter"
                        variant="outlined"
                        onBlur={handleOnBlur}
                      />
                    )}
                  />
               </div>
               <div className="accountedit-form__group-item">
                  <div className="accountedit-form__item-title">
                     <span>部</span>
                  </div>
                  <NativeSelect
                     className="accountedit-form__item-value"
                     id="demo-customized-select-native"
                     value={this.state.user_id || ''}
                     input={<BootstrapInput />}
                     disabled={true}
                  >
                     <option aria-label="無し" value="" />
                     {usersMaster.detailData &&
                        usersMaster.detailData.map((userMaster, index) => (
                           <option value={userMaster.i_num} key={index}>
                              {userMaster.section_name}
                           </option>
                        ))}
                  </NativeSelect>
               </div>

               <div className="accountedit-form__group-item">
                  <div className="accountedit-form__item-title">
                     <span>課</span>
                  </div>
                  <NativeSelect
                     className="accountedit-form__item-value"
                     id="demo-customized-select-native"
                     value={this.state.user_id || ''}
                     input={<BootstrapInput />}
                     disabled={true}
                  >
                     <option aria-label="無し" value="" />
                     {usersMaster.detailData &&
                        usersMaster.detailData.map((userMaster, index) => (
                           <option value={userMaster.i_num} key={index}>
                              {userMaster.department_name}
                           </option>
                        ))}
                  </NativeSelect>
               </div>

               <div className="accountedit-form__group-item">
                  <div className="accountedit-form__item-title">
                     <span>権限</span>
                  </div>
                  <NativeSelect
                     className="accountedit-form__item-value"
                     id="demo-customized-select-native"
                     value={this.state.role || ""}
                     onChange={changeRole}
                     input={<BootstrapInput />}
                     disabled={!kCanEditRole[user.role]}
                  >
                     <option value={"0"}>{kRole[0]}</option>
                     <option value={"1"}>{kRole[1]}</option>
                     <option value={"2"}>{kRole[2]}</option>
                  </NativeSelect>
               </div>

               <div className="accountedit-form__group-item">
                  <div className="accountedit-form__item-title">
                     <span>メールアドレス</span>
                  </div>
                  {/* <input type="text" name="" id="manufacturer" className="accountedit-form__item-value"/> */}
                  <TextField
                     variant="outlined"
                     className="accountedit-form__item-value"
                     value={this.state.login_email}
                     onChange={changeEmail}
                     disabled={true}
                  />
               </div>

               <div className="accountedit-form__group-item">
                  <div className="accountedit-form__item-title">
                     <span>勤務地</span>
                  </div>
                  <NativeSelect
                     className="accountedit-form__item-value"
                     id="demo-customized-select-native"
                     value={this.state.time_zone || ""}
                     onChange={this.changeLocation}
                     input={<BootstrapInput />}
                  >
                     <option value=""></option>
                     <option value="Asia/Tokyo">日本</option>
                     <option value="Asia/Ho_Chi_Minh">ベトナム</option>
                     <option value="America/New_York">アメリカ（ニューヨーク州）</option>
                     <option value="Asia/Bangkok">タイ</option>
                     <option value="Asia/Shanghai">中国</option>
                  </NativeSelect>
               </div>

               <div className="accountedit-form__group-item">
                  <div className="accountedit-form__item-title">
                     <span>二段階認証</span>
                  </div>
                  <NativeSelect
                     className="accountedit-form__item-active-flag"
                     id="demo-customized-select-native"
                     value={this.state.enable2fa}
                     onChange={changeEnable2FA}
                     input={<BootstrapInput />}
                  >
                     <option value={"1"}>オン</option>
                     <option value={"0"}>オフ</option>
                  </NativeSelect>
               </div>

               <div className="accountedit-form__group-item">
                  <div className="accountedit-form__item-title">
                     <span>アカウント</span>
                  </div>
                  <NativeSelect
                     className="accountedit-form__item-active-flag"
                     id="demo-customized-select-native"
                     value={this.state.active_flag == 0 ? this.state.active_flag : 1}
                     onChange={changeActiveFlag}
                     input={<BootstrapInput />}
                     disabled={!kCanEditRole[user.role]}
                  >
                     <option value={"0"}>有効</option>
                     <option value={"1"}>無効</option>
                  </NativeSelect>
               </div>

               <div className="accountedit-form__controls">
                  <button className="accountedit-btn" onClick={handleEdit}>
                     登録
                  </button>
                  <button className="accountexit-btn" onClick={handleExit}>
                     戻る
                  </button>
               </div>

            </div>

            <h1 className="accountedit__heading">パスワードの変更 </h1>
            <div className="accountedit-form">
               <div className="accountedit-form__group-item">
                  <div className="accountedit-form__item-title">
                     <span> 元のパスワード </span>
                  </div>
                  <TextField
                     variant="outlined"
                     className="accountedit-form__item-value"
                     value={this.state.password_now}
                     onChange={changePasswordNow}
                     type={this.state.showPasswordNow ? "text" : "password"}
                     autoComplete="current-password"
                     InputProps={{
                       endAdornment: (
                         <span
                           onClick={toggleShowPasswordNow}
                           style={{
                             cursor: "pointer",
                             color: "gray",
                             fontSize: "24px",
                             userSelect: "none",
                             paddingRight: "4px"
                           }}
                         >
                           {this.state.showPasswordNow ? <Visibility /> : <VisibilityOff />}
                         </span>
                       )
                     }}
                  />
               </div>

               <div className="accountedit-form__group-item">
                  <div className="accountedit-form__item-title">
                     <span>新しいパスワード </span>
                  </div>
                  <TextField
                     variant="outlined"
                     className="accountedit-form__item-value"
                     value={this.state.password_new}
                     onChange={changePasswordNew}
                     type={this.state.showPasswordNew ? "text" : "password"}
                     autoComplete="new-password"
                     InputProps={{
                       endAdornment: (
                         <span
                           onClick={toggleShowPasswordNew}
                           style={{
                             cursor: "pointer",
                             color: "gray",
                             fontSize: "24px",
                             userSelect: "none",
                             paddingRight: "4px"
                           }}
                         >
                           {this.state.showPasswordNew ? <Visibility /> : <VisibilityOff />}
                         </span>
                       )
                     }}
                  />
               </div>

               <div className="accountedit-form__group-item">
                  <div className="accountedit-form__item-title">
                     <span>新しいパスワード(確認用)</span>
                  </div>
                  <TextField
                     variant="outlined"
                     className="accountedit-form__item-value"
                     value={this.state.passwordConfirm}
                     onChange={changePasswordConfirm}
                     type={this.state.showPasswordConfirm ? "text" : "password"}
                     InputProps={{
                       endAdornment: (
                         <span
                           onClick={toggleShowPasswordConfirm}
                           style={{
                             cursor: "pointer",
                             color: "gray",
                             fontSize: "24px",
                             userSelect: "none",
                             paddingRight: "4px"
                           }}
                         >
                           {this.state.showPasswordConfirm ? <Visibility /> : <VisibilityOff />}
                         </span>
                       )
                     }}
                  />
               </div>

            </div>

            <div className="accountpwedit-form__controls" style={{width: kCanResetPW[user.role] ? "300px" : "150px", display: "flex"}}>
               <button className="accountedpw-btn" onClick={handleEditPassword}  
                       style={{
                        width: kCanResetPW[user.role] ? "46%" : "100%",
                        marginLeft: kCanResetPW[user.role] ? "6px" : "0px",
                        marginRight: kCanResetPW[user.role] ? "6px" : "0px",
                       }}
               >
                  変更
               </button>
               <button className="accountedpw-btn" onClick={handleShowResetPassword} 
                       style={{
                        display: kCanResetPW[user.role] ? "block" : "None",
                     }}
               >
                  リセット
               </button>
            </div>

            <div id="overlay" class="overlay" style={{ display: this.state.showPopup ? "block" : "None" }}></div>
            <div id="passwordResetPopup" class="popup" style={{ display: this.state.showPopup ? "block" : "None", width: "700px", height: "200px" }}>    
               <div class="card-header">
                   <h5 class="my-0">パスワードリセット</h5>
               </div>
               <div class="card-body">
                  <div class="input-group mb-3">
                     <div className="accountedit-form__item-title">
                        <span>新しいパスワード</span>
                     </div>
                     <TextField
                        variant="outlined"
                        className="accountedit-form__item-value"
                        value={this.state.password_reset}
                        onChange={changePasswordReset}
                        type={this.state.showPasswordReset ? "text" : "password"}
                        autoComplete="new-password"
                        InputProps={{
                           endAdornment: (
                              <span
                                onClick={toggleShowPasswordReset}
                                style={{
                                  cursor: "pointer",
                                  color: "gray",
                                  fontSize: "24px",
                                  userSelect: "none",
                                  paddingRight: "4px"
                                }}
                              >
                                 {this.state.showPasswordReset ? <Visibility /> : <VisibilityOff />}
                              </span>
                           )
                        }}
                     />
                  </div>
                  <div className="accountpwreset-form__controls">
                     <button className="accountedpwreset-btn" onClick={handleResetPassword}>
                        リセット
                     </button>
                     <button className="accountedpwreset-btn" onClick={handleClosePopup}>
                        キャンセル
                     </button>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

AccountEdit.propTypes = {
   getTerminals: PropTypes.func.isRequired,
};

export default AccountEdit;
